import {CollapsibleSidebar} from '@github-ui/layout-primitives/CollapsibleSidebar'
import {useCollapsibleSidebarState} from '@github-ui/layout-primitives/use-collapsible-sidebar-state'
import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {ReposIssuesSidebar, type ReposIssuesSidebarProps} from './src/ReposIssuesSidebar'
import {CollapsibleFeedbackLink} from './src/CollapsibleFeedbackLink'

import {SIDEBAR_STORAGE_KEY} from './src/constants'

/**
 * Wraps `ReposIssuesSidebar` for the standalone Rails partial. Provides the
 * `Repository navigation` landmark via `<CollapsibleSidebar ariaLabel>` so
 * AT users still get a labelled landmark.
 */
export function CollapsiblePartialSidebar(props: Omit<ReposIssuesSidebarProps, 'forceHardNavigation'>) {
  const {isExpanded, toggle} = useCollapsibleSidebarState({storageKey: SIDEBAR_STORAGE_KEY})
  return (
    <CollapsibleSidebar
      isExpanded={isExpanded}
      ariaLabel="Repository navigation"
      expandedWidth="small"
      footer={
        <>
          <CollapsibleFeedbackLink isExpanded={isExpanded} />
          <CollapsibleSidebar.Toggle isExpanded={isExpanded} onToggle={toggle} />
        </>
      }
    >
      <ReposIssuesSidebar {...props} forceHardNavigation collapsible />
    </CollapsibleSidebar>
  )
}

registerReactPartial('repos-issues-sidebar', {
  Component: (props: Omit<ReposIssuesSidebarProps, 'forceHardNavigation'>) => {
    return <CollapsiblePartialSidebar {...props} />
  },
})
